<div class="validationContainer" *ngIf="controlToValidate && (controlToValidate.invalid && isSubmitted)">
  <div *ngFor="let errorKey of controlToValidate.errors | objectToKeys">
    <qpoint-icon icon="exclamation-circle"></qpoint-icon>
    <span *ngIf="controlToValidate.errors[errorKey].value">{{(controlToValidate.errors[errorKey].value) | translate:{value: controlToValidate.errors[errorKey].parameter} }}</span>
    <span *ngIf="!controlToValidate.errors[errorKey].value && errorKey !== 'maxlength' ">{{('common.validators.' + errorKey) | translate}}</span>
    <span *ngIf="!controlToValidate.errors[errorKey].value && errorKey === 'maxlength' ">{{('common.validators.maxLength') | translate:{'0': controlToValidate.errors[errorKey].requiredLength} }}</span>
  </div>
</div>

